import React from 'react';
import "./line.scss"

function CustomLine({width}) {
    return ( <>
    <div className='line-main' style={{width:width}}>
        <span className='line-first-part'></span>
        <span className='line-second-part'></span>
    </div>
    </> );
}

export default CustomLine;